/**
 * Centralized chart theme configuration.
 * Colors match the indigo-violet dark theme.
 */

import type { CSSProperties } from 'react';

export const COST_COLORS = {
  infrastructure: '#22d3ee',
  ecoles: '#34d399',
  creches: '#a78bfa',
  co: '#fb7185',
  sport: '#22d3ee',
  culturel: '#fb7185',
  espaces_publics: '#6366f1',
} as const;

export const CHART_COLORS = [
  '#6366f1', '#22d3ee', '#34d399', '#a78bfa',
  '#fbbf24', '#fb7185', '#818cf8', '#60a5fa',
];

export const AXIS_STYLE = {
  fill: '#94a3b8',
  fontSize: 11,
  fontFamily: "'Inter', -apple-system, sans-serif",
};

export const GRID_STYLE = {
  stroke: 'rgba(255,255,255,0.04)',
  strokeDasharray: '3 3',
};

export function buildCostDonutData(b: {
  infrastructure: number;
  ecoles: number;
  creches: number;
  co: number;
  sport: number;
  culturel: number;
  espaces_publics: number;
}) {
  return [
    { name: 'Infrastructure', value: b.infrastructure, color: COST_COLORS.infrastructure },
    { name: 'Écoles', value: b.ecoles, color: COST_COLORS.ecoles },
    { name: 'Crèches', value: b.creches, color: COST_COLORS.creches },
    { name: 'CO', value: b.co, color: COST_COLORS.co },
    { name: 'Sport', value: b.sport, color: COST_COLORS.sport },
    { name: 'Culturel', value: b.culturel, color: COST_COLORS.culturel },
    { name: 'Espaces publics', value: b.espaces_publics, color: COST_COLORS.espaces_publics },
  ];
}

export const TOOLTIP_STYLE: CSSProperties = {
  background: '#161625',
  backdropFilter: 'blur(12px)',
  border: '1px solid rgba(148,163,184,0.1)',
  borderRadius: '8px',
  color: '#f1f5f9',
  fontSize: '12px',
  padding: '10px 14px',
  boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
};
